const getDefaultState = () => {
    return {
    };
};

const initialState = getDefaultState();

const getters = {

};

export const state = { ...initialState };

export const actions = {
    // setters

    // other actions
};

export const mutations = {

};

export default {
    state,
    actions,
    mutations,
    getters,
};
